import Vue from 'vue';
// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';
import './plugins/alerts';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import EventBus from './plugins/bus';
import './plugins/axios';
import './plugins/slugify';
import './plugins/acl';
import './plugins/filters';

// // Monitoriamento
// Sentry.init({
//   dsn: 'https://d4c6131ebfe744b6acc3659f8609919a@sentry.io/4069141',
//   integrations: [new Integrations.Vue({ Vue, attachProps: true })],
// });

Vue.use(EventBus);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
